import { setMediaEditor } from "Actions";

export const openMediaEditor = media => {
  return (dispatch, getState) => {
    const { auth } = getState();

    if (media.docType === "ALBUM") {
      return;
    }

    if (auth.loggedAs === "GUEST") {
      return false;
    }

    let mediaEditor = {
      media: media,
      isOpen: true,
      ...{
        titleFR: media.titleFr || "",
        titleEN: media.titleEn || "",
        titleNL: media.titleNl || "",
        descriptionFR: media.descriptionFr || "",
        descriptionEN: media.descriptionEn || "",
        descriptionNL: media.descriptionNl || "",
        altFR: media.altFr || "",
        altEN: media.altEn || "",
        altNL: media.altNl || "",
        copyrightFR: media.copyrightFr || "",
        copyrightEN: media.copyrightEn || "",
        copyrightNL: media.copyrightNl || "",
        tags: media.tags,
        creator: media.creator,
        taggedUsers: media.taggedUsers,
        mediaStatus: media.mediaStatus,
        csScope: media.csScope,
        isPrivate: media.isPrivate,
        inTheNews: media.inTheNews,
        languages: media.languages
          ? media.languages.split(",").sort()
          : ["FR", "NL", "EN"].sort()
      }
    };

    if (media.preview && ["VIDEO", "PDF", "PPT"].includes(media.docType)) {
      mediaEditor.media = media.preview;
    }

    return dispatch(setMediaEditor(mediaEditor));
  };
};



// WEBPACK FOOTER //
// ./src/actions/thunks/media-editor.js